<template>
  <div class="main partner">
    <div class="head">
      <span style="margin-bottom: 0.3rem">智慧伊旗农牧大数据平台</span>
    </div>
    <div class="section">
      <div class="gobcak" @click="goBack"><img src="../../../assets/yq/yiqi_back.png" alt="" /><span>返回上一层</span></div>
      <div class="box">
        <div class="box-item">
          <div class="top-l">
            <chartTitle title="种植面积分析"></chartTitle>
            <div class="plant_centent">
              <div class="center">
                <div class="num">
                  <div class="title">种植总面积(亩)</div>
                  <div class="card">
                    <div class="card-num">3</div>
                    <div class="card-num">5</div>
                    <div class="card-num">7</div>
                    <div class="card-num">6</div>
                  </div>
                </div>
                <!-- <div class="pie" id="areaChart"></div> -->
                <dv-active-ring-chart style="width: 100%;height: 3rem;" :config="config" />
                <div class="map-font">
                  <div class="font-box" v-for="(item, index) in lineData" :key="index">
                    <div class="radio" :style="{ backgroundColor: item.color }"></div>
                    <div>{{ item.name }}</div>
                    <div>{{ item.value }}%</div>
                    <div>{{ item.total }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="warrning">
            <chartTitle title="总产量分析"></chartTitle>
            <!-- .warrning_icon_1.png -->
            <div class="warrning_content">
              <div class="center">
                <div class="num">
                  <div class="title">总产量(吨)</div>
                  <div class="card">
                    <div class="card-num">3</div>
                    <div class="card-num">5</div>
                    <div class="card-num">7</div>
                    <div class="card-num">6</div>
                    <div class="font">.</div>
                    <div class="card-num">6</div>
                  </div>
                </div>
                <!-- <div class="pie" id="numPieChart"></div> -->
                <dv-active-ring-chart style="width: 100%;height: 3rem;" :config="config" />
                <div class="map-font">
                  <div class="font-box" v-for="(item, index) in lineData" :key="index">
                    <div class="radio" :style="{ backgroundColor: item.color }"></div>
                    <div>{{ item.name }}</div>
                    <div>{{ item.value }}%</div>
                    <div>{{ item.total }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-center">
          <div class="tips">
            <div class="env">
              <div><img src="../../../assets/yq/device_icon_3.png" alt="" srcset="" /></div>
              <div>
                <label>环境检测设备</label>
                <span>5</span>
              </div>
            </div>
            <div class="env">
              <div><img src="../../../assets/yq/device_icon_4.png" alt="" srcset="" /></div>
              <div class="env-text">
                <label>土壤检测设备</label>
                <span>5</span>
              </div>
            </div>
          </div>
          <div id="mapMain" class="map_main"></div>
        </div>
        <div class="box-item">
          <div class="device">
            <chartTitle title="产量趋势" :optionsList="outList"></chartTitle>
            <div class="device_content" id="lineChart"></div>
          </div>
          <div class="service">
            <chartTitle title="区域对比" :optionsList="areaList"></chartTitle>
            <div class="service_content" id="columnChart"></div>
          </div>
        </div>
      </div>
      <video src="../../../assets/yq/yqScreenVideo.mp4" autoplay="autoplay" loop class="fillWidth" muted='muted'>
        </video>
    </div>

    <model :dialogVisible="dialogVisible" :title="title" :modelParams="modelParams"></model>
  </div>
</template>
<script>
import chartTitle from './components/indexChartItemTitle.vue'
import mapJson from '../../../assets/map/150627.json'
import model from './components/model.vue'
export default {
  components: {
    chartTitle,
    model,
  },
  data() {
    return {
      outList: [{ value: 1, label: '全区域' }],
      areaList: [
        { value: 1, label: '2023' },
        { value: 2, label: '2022' },
      ],
      title: '伊金霍洛旗',
      modelParams: {},
      lineData: [
        { value: 45, name: '大豆', total: '837.5', color: '#F7BA1E ' },
        { value: 40.2, name: '小麦', total: '734.8', color: '#14C9C9' },
        { value: 60.2, name: '甜菜', total: '123.3', color: '#3491FA ' },
        { value: 54.2, name: '玉米', total: '643.5', color: '#165DFF' },
        { value: 30.2, name: '土豆', total: '467.7', color: '#722ED1' },
      ],
      dialogVisible: false,
      currentItem: '',
      config: {
        radius: '40%',
        activeRadius: '45%',
        data: [
          {
            name: '大豆',
            value: 837.5
          },
          {
            name: '小麦',
            value: 734.8
          },
          {
            name: '甜菜',
            value: 123.3
          },
          {
            name: '玉米',
            value: 643.5
          },
          {
            name: '土豆',
            value: 467.7
          }
        ],
        showOriginValue: true,
        digitalFlopStyle: {
          fontSize: 16
        }
      }
    }
  },
  watch: {},
  created() { },
  mounted() {
    const mapData = [
      {
        name: '纳林陶亥镇',
        value: [110.11966302149337, 39.6283242456816],
      },
    ]
    const regions = [
      {
        name: '红庆河镇',
        itemStyle: { color: 'rgba(26, 87, 86, 0.4)' },
      },
      {
        name: '纳林陶亥镇',
        itemStyle: { color: 'rgba(17, 45, 109, 1)' },
      },
    ]
    this.draw(mapData, regions)
    this.$nextTick(() => {
      // this.pieChart1({
      //   dom: 'areaChart',
      // })
      // this.pieChart2({
      //   dom: 'numPieChart',
      // })
      this.initLineChart({
        dom: 'lineChart',
        xAxis: ['2000年', '2001年', '2002年', '2003年', '2004年', '2005年', '2006年', '2022年', '2023年'],
        data: [3500, 6000, 4500, 3000, 7500, 4000, 3200, 8400, 5000],
      })
      this.initColumnChart()
    })
  },
  methods: {
    // 返回上一层
    goBack() {
      this.$router.go(-1)
    },
    // 初始化pie1
    pieChart1(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        title: [
          {
            text: '',
            top: 'center',
            left: 'center',
          },
        ],
        legend: {
          show: false,
          top: 'bottom',
          icon: 'circle',
          x: 'left',
          y: ' center',
          padding: [0, 0, 40, 40],
          textStyle: {
            color: '#FFFFFF',
          },
          formatter: (name) => {
            console.log(name)
            // return this.getFormatter(name)
          },
        },
        grid: {
          left: '10%',
          right: '10%',
        },
        color: ['#F7BA1E', '#14C9C9', '#3491FA', '#165DFF', '#722ED1'], // 饼图各块颜色
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: 'Nightingale Chart',
            type: 'pie',
            radius: [50, 110],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 0,
            },
            tooltip: {
              trigger: 'item',
              axisPointer: {
                type: 'shadow',
              },
              // backgroundColor: 'rgba(11, 15, 56, 1)',
              // borderColor: 'rgba(18, 36, 132, 1)',
              // borderWidth: 2,
              // textStyle: {
              //     color: '#fff',
              // },
              backgroundColor: 'rgba(255,255,255,0.8)',
              borderColor: '#292929',
              borderWidth: 1,
              textStyle: {
                color: '#050F37',
              },
            },
            label: {
              position: 'inner',
              fontSize: 14,
              show: false,
              // formatter: '{b}\n   {d}% ',
              formatter: function (params) {
                if (params.percent === undefined) {
                  return params.name + 0 + '%'
                } else if (params.percent === 0) {
                  return params.name + params.percent + '%'
                } else {
                  return params.name + params.percent + '%'
                }
              },
            },
            emphasis: {
              // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
              label: {
                // label高亮时的配置
                show: true,
                textStyle: {
                  color: '#fff', // 高亮时标签颜色变为 白色
                  fontSize: 15, // 高亮时标签字体 变大
                  fontWeight: 'bold',
                },
                borderColor: '#fff',
                padding: 5,
                extraCssText: 'box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;',
                formatter: '{b} \n {d} ',
              },
            },
            legend: {
              // left:'1%',
              bottom: '3%',
              icon: 'circle',
              textStyle: {
                color: '#6FB6FF',
                fontWeight: 400,
                fontFamily: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC',
              },
              // left:'10%'
            },
            itemStyle: {
              borderWidth: 5, //设置border的宽度有多大
              // borderColor:, // 设置后饼图间会有白色空隙
            },
            data: this.lineData,
          },
        ],
      })
    },
    // 初始化top-pie2
    pieChart2(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        title: [
          {
            text: '',
            top: 'center',
            left: 'center',
          },
        ],
        legend: {
          show: false,
          top: 'bottom',
          icon: 'circle',
          x: 'left',
          y: ' center',
          padding: [0, 0, 40, 40],
          textStyle: {
            color: '#FFFFFF',
          },
          formatter: (name) => {
            console.log(name)
            // return this.getFormatter(name)
          },
        },
        grid: {
          left: '10%',
          right: '10%',
        },
        color: ['#F7BA1E', '#14C9C9', '#3491FA', '#165DFF', '#722ED1'], // 饼图各块颜色
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: 'Nightingale Chart',
            type: 'pie',
            radius: [50, 110],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 0,
            },
            tooltip: {
              trigger: 'item',
              axisPointer: {
                type: 'shadow',
              },
              // backgroundColor: 'rgba(11, 15, 56, 1)',
              // borderColor: 'rgba(18, 36, 132, 1)',
              // borderWidth: 2,
              // textStyle: {
              //     color: '#fff',
              // },
              backgroundColor: 'rgba(255,255,255,0.8)',
              borderColor: '#292929',
              borderWidth: 1,
              textStyle: {
                color: '#050F37',
              },
            },
            label: {
              position: 'inner',
              fontSize: 14,
              show: false,
              // formatter: '{b}\n   {d}% ',
              formatter: function (params) {
                if (params.percent === undefined) {
                  return params.name + 0 + '%'
                } else if (params.percent === 0) {
                  return params.name + params.percent + '%'
                } else {
                  return params.name + params.percent + '%'
                }
              },
            },
            emphasis: {
              label: {
                show: true,
                formatter: data.roseType ? '{a|{c}}\n{b|{b}} ' : '{b|{b}}\n{a|{d}%} ',
                rich: {
                  a: {
                    fontSize: 20,
                    lineHeight: 36,
                    color: '#fff',
                    fontWeight: 'bold',
                  },
                  b: {
                    fontSize: 12,
                    lineHeight: 24,
                    color: '#fff',
                  },
                },
              },
            },
            label: {
              show: false,
              position: 'center',
              color: 'rgba(13, 17, 29,1)',
              fontSize: 14,
              formatter: '{a|{b}}\n{b|{c}} ',
              rich: {
                a: {
                  fontSize: 20,
                  lineHeight: 36,
                  color: '#fff',
                },
                b: {
                  fontSize: 16,
                  lineHeight: 24,
                  color: '#fff',
                },
              },
            },
            legend: {
              // left:'1%',
              bottom: '3%',
              icon: 'circle',
              textStyle: {
                color: '#6FB6FF',
                fontWeight: 400,
                fontFamily: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC',
              },
              // left:'10%'
            },
            itemStyle: {
              borderWidth: 5, //设置border的宽度有多大
              // borderColor:, // 设置后饼图间会有白色空隙
            },
            data: this.lineData,
          },
        ],
      })
    },
    draw(data, regions) {
      const _this = this
      // 基于准备好的dom，初始化echarts实例
      var chart = this.$echarts.init(document.getElementById('mapMain'))

      this.$echarts.registerMap('bayannaoer', mapJson)
      // 隐藏动画加载效果。
      chart.hideLoading()

      let cahrtOption = {
        geo3D: {
          silent: false,
          type: 'map3D', // 系列类型
          name: 'map3D', // 系列名称
          map: 'bayannaoer',
          boxHeight: 4,
          zoom: 1,
          label: {
            // 标签的相关设置
            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
            //distance: 50, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
            //formatter:, // 标签内容格式器
            textStyle: {
              // 标签的字体样式
              color: '#000', // 地图初始化区域字体颜色
              fontSize: 8, // 字体大小
              opacity: 1, // 字体透明度
              backgroundColor: 'rgba(0,23,11,0)', // 字体背景色
            },
          },

          itemStyle: {
            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
            color: 'rgba(51, 119, 171, 0.3)', // 地图板块的颜色
            opacity: 1, // 图形的不透明度 [ default: 1 ]
            borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
            borderColor: 'rgba(111,202,242, 0.8)', // 图形描边的颜色。[ default: #333 ]
          },
          groundPlane: {
            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
            show: false, // 是否显示地面。[ default: false ]
          },
          light: {
            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
            main: {
              // 场景主光源的设置，在 globe 组件中就是太阳光。
              color: '#fff', //主光源的颜色。[ default: #fff ]
              intensity: 1.2, //主光源的强度。[ default: 1 ]
              shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
              shadowQuality: 'high', // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
              alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
              beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
            },
          },

          viewControl: {
            // 用于鼠标的旋转，缩放等视角控制。
            projection: 'orthographic', // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
            autoRotateDirection: 'cw', // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
            rotateSensitivity: 1, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
            zoomSensitivity: 1, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
            panMouseButton: 'left', // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
            rotateMouseButton: 'left', // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
            orthographicSize: 100,
            distance: 200, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。

            alpha: 40, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
            beta: 15, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
            minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
            maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
            minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
            maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]

            center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。

            animation: true, // 是否开启动画。[ default: true ]
            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
            animationEasingUpdate: 'cubicInOut', // 过渡动画的缓动效果。[ default: cubicInOut ]
          },
          regions: regions,
        },
        series: [
          {
            name: '红庆河镇',
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol: 'image://' + require('@/assets/yq/荞麦.png'),
            symbolSize: 32,
            itemStyle: {
              normal: {
                color: '#8c3819',
              },

            },
            data: [
              {
                name: '红庆河镇',
                value: [109.54305019089168, 39.49146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.70305019089168, 39.52146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.60305019089168, 39.40146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.59305019089168, 39.87146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.33368711988757, 39.735118211159,],
              },
              {
                name: '纳林陶亥镇',
                value: [110.09666302149337, 39.6983242456816, 100],
              },
              {
                name: '纳林陶亥镇',
                value: [110.19666302149337, 39.5483242456816, 100],
              },
              {
                name: '红庆河镇',
                value: [109.10168711988757, 39.665118211159,],
              },
            ],
          },
          {
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol: 'image://' + require('@/assets/yq/马铃薯.png'),
            symbolSize: 32,
            itemStyle: {
              normal: {
                color: '#d4a74f',
              },

            },
            data: [
              {
                name: '红庆河镇',
                value: [109.41305019089168, 39.49146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.31305019089168, 39.52146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.60305019089168, 39.40146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.18305019089168, 39.56146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.41368711988757, 39.735118211159,],
              },

            ],
          },
          {
            name: '红庆河镇',
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol: 'image://' + require('@/assets/yq/谷子.png'),
            symbolSize: 32,
            itemStyle: {
              normal: {
                color: '#a4af60',
              },

            },
            data: [
              {
                name: '红庆河镇',
                value: [109.46305019089168, 39.43146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.25305019089168, 39.40146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.65305019089168, 39.40146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.25305019089168, 39.55146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.63368711988757, 39.735118211159,],
              },

            ],
          },
          {
            name: '红庆河镇',
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol: 'image://' + require('@/assets/yq/糜黍.png'),
            symbolSize: 28,
            itemStyle: {
              normal: {
                // borderColor:'#FF8400',
                color: '#ebbe7b',
              },
              // effect: {
              //     show: true,
              //     shadowBlur: 10,
              //     loop: true
              // },

            },
            data: [
              {
                name: '纳林陶亥镇',
                value: [110.06666302149337, 39.6283242456816, 100],
              },
              {
                name: '纳林陶亥镇',
                value: [109.79652060957247, 39.49194198364336, 110],
              },
              {
                name: '红庆河镇',
                value: [109.49305019089168, 39.43146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.32305019089168, 39.45146024913993,],
              },
              {
                name: '红庆河镇',
                value: [109.63368711988757, 39.635118211159,],
              },
              {
                name: '红庆河镇',
                value: [109.64912170340222, 39.50674841166803],
              },
              {
                name: '红庆河镇',
                value: [109.99333118611193, 39.53926770577715],
              },

            ],
          },

          {
            name: '纳林陶亥镇',
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol:
              'path://M845.7 641h0.1l-0.1-21.1z,M362.7 666.4v-96.3c0-51.2-17-101.6-50.8-140.1-29-32.9-72.8-61.8-137.5-61.8 0 0 360.9-150 360.9 156.9v141.2-5.3 104.5S526.9 900 645.5 919.9c7.1 1.2 8 11 1.1 13.2-86.5 28.1-283.9 85-283.9-167.6V661.1v5.3z,M573.9 449.9c-25 10.5-39.8 34-38.5 58.8 0.3 5.3 0.4 10.8 0.4 16.5V765.6s-0.2 0.9-0.6 2.3c-0.5 17.1 0.5 133.3 109.8 152-1.8-29.9-25.3-477.4 204.5-415.8 0.1 0.1-145.9-108.9-275.6-54.2z,M625.3 159.1c0-0.2-0.1-0.2-0.1-0.3-36-94.6-109.7-93.9-109.7-93.9s-73.8-0.7-109.7 93.9c-0.1 0.2-0.1 0.2-0.1 0.3-0.8 2.7-17.5 58.1-27.1 171.8-0.1 0.8 0.3 1.4 0.6 2.1 68.6 6.4 132.3 39.5 150.8 133.1 5.8-7.2 13.2-13.2 22-17.2 28.9-13 58.6-16.3 86.9-13.9 4.7-0.3 9.5-0.4 14.2-0.4 1.1-1 2.2-1.9 3.7-3.2v-37.1c-7.9-156.8-30.6-232.2-31.5-235.2z,M656.6 397.9h-39.9v-50h37c-0.8-10.9-1.7-21.5-2.6-31.4h-34.4v-50h28.8c-1.5-11.3-3-21.9-4.5-31.4h-24.4v-50h15.1c-3.6-16.4-6.2-25-6.5-26 0-0.2-0.1-0.2-0.1-0.3-0.7-1.8-1.5-3.3-2.2-5.1h-6.3v-13.9c-20.2-40.2-47.6-58.9-68.9-67.5h-12.5v-4.2c-11.9-3.2-19.9-3.2-19.9-3.2s-4.4 0-11.5 1.3v6.2h-21c-18.4 7.5-41.5 22.6-60.5 52.6v28.8h-14.7c-0.7 1.7-1.5 3.3-2.2 5.1-0.1 0.2-0.1 0.2-0.1 0.3-0.3 1-2.9 9.6-6.5 26h23.5v50h-32.7c-1.5 9.5-3 20-4.5 31.4h37.2v50h-42.8c-0.4 4.7-0.9 9.4-1.3 14.4-0.1 0.8 0.3 1.4 0.6 2.1 26.5 2.5 52.2 9 74.9 21.3v-6.5h50v50h-1.6c12.4 18 22 40.4 27.5 68.2 1.6-2 3.6-3.7 5.5-5.5v-31.4h50v8.8c10.5-2.2 21-3.4 31.4-3.7v-5.1h39.9v-31.3z m-152.7-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z m81.4 244.2h-50v-50h50v50z m0-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z',
            symbolSize: 20,
            itemStyle: {
              normal: {
                color: '#FFF200',
              },
            },
            data: [
              {
                name: '纳林陶亥镇',
                value: [110.01666302149337, 39.6283242456816, 100],
              },
              {
                name: '纳林陶亥镇',
                value: [110.09666302149337, 39.6283242456816, 100],
              },
              {
                name: '纳林陶亥镇',
                value: [109.74652060957247, 39.49194198364336, 110],
              },
              {
                name: '红庆河镇',
                value: [109.37305019089168, 39.43146024913993],
              },
            ],
          },
          // {
          //   name: '红庆河镇',
          //   // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
          //   type: 'scatter3D',
          //   coordinateSystem: 'geo3D',
          //   // symbol: 'image://' + require('@/assets/yq/高粱.png'),
          //   // symbol: `path://M70.8 485.9l625.9 399.9 262.1-163.9-617.5-409.7z,M829.3 802.9L185.6 400.4l151.9-85.6 621.3 407.1z,M325.5 138.2l3.4 183 629.9 400.7 1.2-191.8z,M233.7 412.6l-132.1 83.9 11.8 11.1 138.5-85.2zM342.3 481.7l-132.1 84 11.8 11 138.4-85.2zM449 550.9l-132.1 83.9 11.8 11.1 138.4-85.2zM558.7 620.3l-132.1 83.9 11.8 11.1 138.5-85.2zM666.2 689.3l-132.1 83.9 11.8 11.1 138.4-85.2zM776.7 758.3l-132.1 84 11.8 11 138.4-85.2z,M120.4 498.2c0 5.4-5.3 9.4-11.8 9.4-6.5 0-11.8-3.8-11.8-11.1V341.8c0-7.2 23.6-5.6 23.6 1.6v154.8z,M119 348.9c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.3 5.3 11.7 11.8 12.5 6.5 0.8 11.8-2.6 11.8-8v-15.8c-0.4-0.3-0.9-0.4-1.4-0.6z,M228.9 567.4c0 5.3-5.3 9.4-11.8 9.4-6.5 0-11.8-3.8-11.8-11.1V411c0-7.2 23.6-5.6 23.6 1.6v154.8z,M227.5 418c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.4 6.5 0.8 11.8-2.6 11.8-8v-15.8c-0.4-0.1-0.9-0.3-1.4-0.5z,M337.5 636.6c0 5.4-5.3 9.4-11.8 9.4-6.5 0-11.8-3.9-11.8-11.1V480.1c0-7.2 23.6-5.6 23.6 1.6v154.9z,M336 487.2c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.5 6.5 0.8 11.8-2.7 11.8-8v-15.8c-0.4-0.3-0.9-0.4-1.4-0.6z,M446 705.7c0 5.3-5.3 9.3-11.8 9.3-6.5 0-11.8-3.8-11.8-11.1V549.3c0-7.2 23.6-5.6 23.6 1.6v154.8z,M444.5 556.3c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.5 6.5 0.7 11.8-2.6 11.8-8v-15.8c-0.4-0.2-0.9-0.3-1.4-0.6z,M554.5 774.9c0 5.3-5.3 9.3-11.8 9.3-6.5 0-11.8-3.8-11.8-11.1V618.4c0-7.2 23.6-5.6 23.6 1.6v154.9z,M553 625.5c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.4 6.5 0.7 11.8-2.7 11.8-8V626c-0.4-0.2-0.9-0.3-1.4-0.5z,M663 844c0 5.3-5.3 9.4-11.8 9.4-6.5 0-11.8-3.8-11.8-11.1V687.6c0-7.2 23.6-5.6 23.6 1.6V844z,M661.5 694.6c-8.1-3.8-15.2-5.2-22.1-8.9v20.8c0 7.2 5.3 11.7 11.8 12.4 6.5 0.8 11.8-2.6 11.8-7.9v-15.8l-1.5-0.6z,M64 323.2l627.4 398.7L960 552.5v-22.4L325.5 138.2 64 299z,M64 299l625.9 400L960 530.1 325.5 138.2z,M910.2 564.1v188.2l48.6-30.4 1.2-191.8z`,
          //   symbolSize: 70,
          //   itemStyle: {
          //     normal: {
          //       color: '#ccc',
          //       areaColor: {
          //         repeat: 'repeat',
          //       },
          //     },
          //     areaStyle: {
          //       opacity: 1,
          //     },
          //   },
          //   data: [
          //     {
          //       name: '红庆河镇',
          //       value: [109.24529833729624, 39.40334414691, 100],
          //     },

          //     {
          //       name: '红庆河镇',
          //       value: [109.48529833729624, 39.40334414691005, 100],
          //     },
          //     {
          //       name: '红庆河镇',
          //       value: [109.93677031857868, 39.52449428415719],
          //     },
          //   ],
          // },
        ],
        emphasis: {
          // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
          label: {
            // label高亮时的配置
            show: false,
            textStyle: {
              color: '#fff', // 高亮时标签颜色变为 白色
              fontSize: 15, // 高亮时标签字体 变大
            },
            borderColor: '#08DAC8',
            borderWidth: 2,
            padding: 5,
            backgroundColor: 'red',
            extraCssText: 'box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;',
            formatter: function (params) {
              console.log(params)
              _this.currentItem = params
              return
            },
          },
        },
      }

      chart.setOption(cahrtOption)
      chart.getZr().on('click', (params) => {
        console.log(_this.currentItem)
        if (_this.currentItem.name == '红庆河镇') {
          _this.dialogVisible = true
          _this.title = _this.currentItem.name
        }
      })
    },
    // 初始化折线图
    initLineChart(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        color: ['rgba(0,246,236,1)'],
        title: {
          text: '',
        },
        legend: {
          icon: 'rectangle',
          data: [
            {
              name: '',
              textStyle: {
                fontSize: 12,
                color: 'rgba(0,246,236,1)',
              },
            },
          ],
          x: 'right',
          y: 'top',
          itemWidth: 15,
          itemHeight: 2,
          padding: [30, 0, 0, 0],
        },
        /* tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(196,196,196,0.01);',
          borderColor: ' rgba(0,246,236,0.2)',
          boxShadow: 'inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
          },
          formatter: function (data) {
            let dom = ''
            data.forEach((item) => {
              dom += `<p>
                                ${item.marker}
                                ${item.seriesName}：
                                ${item.value}只
                            </p>`
            })
            return `<div>${dom}</div>`
          },
        }, */
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(196,196,196,0.01);',
          borderColor: ' rgba(0,246,236,0.2)',
          boxShadow: 'inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: '0%',
          right: '6%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: '#05E9F7',
              interval: 0,
              // rotate: 40,
            },
            axisLine: {
              show: true, // X轴 网格线 颜色类型的修改
              lineStyle: {
                color: ' rgba(0,254,255,0.1)',
              },
            },
            axisTick: {
              // X轴线 刻度线
              show: false,
            },
            data: data.xAxis,
          },
        ],
        yAxis: [
          {
            name: '单位：吨',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [1, 1],
            },
            splitLine: false,
            type: 'value',
            axisLine: {
              show: true, // Y轴线
              lineStyle: {
                color: ' rgba(0,254,255,0.1)',
              },
            },
            axisLabel: {
              color: '#FFFFFF',
            },
          },
        ],
        series: [
          {
            name: '',
            type: 'line',
            lineStyle: {
              width: 2,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(91,233,255,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(0,246,236,0.48)',
                },
              ]),
            },
            data: data.data,
          },
        ],
      })
    },

    // 初始化柱状图
    initColumnChart() {
      this.chart = this.$echarts.init(document.getElementById('columnChart'))
      // 隐藏动画加载效果。
      this.chart.setOption({
        color: ['#165DFF', '#F7BA1E', '#722ED1', '#14C9C9', '#3491FA'],
        legend: {
          icon: 'circle',
          color: 'rgba(0,246,236,1)',
          data: [
            {
              name: '玉米',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '大豆',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '土豆',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '小麦',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
            {
              name: '甜菜',
              textStyle: {
                fontSize: 12,
                color: '#fff',
              },
            },
          ],
          x: 'center',
          y: 'top',
          itemWidth: 8,
          itemHeight: 8,
          padding: [30, 0, 0, 0],
          borderRadius: '50%',
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(196,196,196,0.01);',
          borderColor: ' rgba(0,246,236,0.2)',
          boxShadow: 'inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)',
          borderWidth: 2,
          textStyle: {
            color: '#fff',
          },
          formatter: function (data) {
            const name = data[0].name.split('\n')[0]
            let dom = `<div style='width: 150px'>
                            <h3 style='
                                text-align: center;
                                font-size: 16px;
                                font-weight: 400;
                                color: #FFFFFF;'>${name}</h3>
                            <div style='display: flex; flex-wrap: wrap'>
                        `
            data.forEach((item) => {
              dom += `<div style='width: 50%; display: flex;'>
                                <p>${item.marker}</p>
                                <div>
                                    <p style='color: #00FEFF;font-weight: 700;'>${item.value}</p>
                                    <p>${item.seriesName}</p>
                                </div>
                            </div>`
            })
            return `<div>${dom}</div>`
          },
        },
        grid: {
          left: '5%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [
              {
                value: '阿勒腾席热镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '乌兰木伦镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '伊金霍洛镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '设札萨克镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '纳林陶亥镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '红庆河镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              {
                value: '苏布尔嘎镇',
                textStyle: {
                  lineHeight: 16,
                  formatter: ['{a}', '{b}'].join('\n'),
                },
              },
              // {
              //   value: '伊旗',
              //   textStyle: {
              //     lineHeight: 16,
              //     formatter: ['{a}', '{b}'].join('\n'),
              //   },
              // },
            ],
            axisPointer: {
              type: 'shadow',
            },
            axisLine: {
              show: true, // Y轴线
              lineStyle: {
                color: ' rgba(0,254,255,0.1)',
              },
            },
            axisTick: {
              // X轴线 刻度线
              show: false,
            },
            axisLabel: {
              color: '#05E9F7',
              rotate:30,
            },
          },
        ],
        yAxis: [
          {
            name: '单位：吨',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [1, 1],
            },
            splitLine: false,
            axisLabel: {
              color: '#FFFFFF',
            },
          },
          {
            show: true,
          },
        ],
        series: [
          {
            name: '玉米',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [76.7, 135.6, 162.2, 32.6, 23.4, 763, 334, 212],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#165DFF',
            },
          },
          {
            name: '大豆',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [28.7, 70.7, 175.6, 182.2, 343, 123, 234, 34],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#F7BA1E',
            },
          },
          {
            name: '土豆',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [70.7, 175.6, 182.2, 48.7, 98, 76, 35, 124],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#722ED1',
            },
          },
          {
            name: '小麦',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [175.6, 182.2, 48.7, 18.8, 88, 77, 89, 120],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#14C9C9',
            },
          },
          {
            name: '甜菜',
            type: 'bar',
            barWidth: '6',
            barGap: 0,
            data: [17.6, 82.2, 148.7, 87.8, 98, 345, 87, 75],
            emphasis: {
              focus: 'series',
            },
            itemStyle: {
              //   barBorderRadius: [20, 20, 0, 0],
              color: '#3491FA',
            },
          },
        ],
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.main {
  width: 24rem;
  // height: 13.5rem;
  min-height: 100vh;
  margin: 0 auto;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // background: url('../../../assets/yq/agriculture_bg.png');

  .head {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 1.2rem;
    background: url('../../../assets/yq/head_index_bg.png');
    background-size: 100% 100%;
    font-size: 0.55rem;
    font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 5px;
  }

  .section {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    // min-height: 12.5rem;
    // min-height: calc(100vh - 1rem);
    position: relative;
    border: none;

    .gobcak {
      width: 2.25rem;
      height: 0.4375rem;
      position: absolute;
      z-index: 99;
      top: 0.175rem;
      left: 0.25rem;
      font-size: 0.2rem;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: #fdfdfd;
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        width: 0.3rem;
        height: 0.3rem;
      }

      span {
        margin-left: 0.05rem;
      }
    }

    .box {
      width: 100%;
      display: flex;
      // background: url('../../../assets/yq/fold/rectangle1.png');
      background-size: 100% 100%;
      margin-top: 1rem;
      padding: 0 0.26rem;

      .box-item {
        .top-l {
          background: linear-gradient(90deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(11, 40, 106, 0.62) 100%);
        }

        width: 5.75rem;

        .plant_centent {
          width: 5.75rem;
          height: 4.78rem;
          // background: linear-gradient(90deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(11, 40, 106, 0.62) 100%);
          opacity: 0.94;
          margin-top: 0.11rem;
          display: flex;

          .plant_type {
            display: flex;
            padding-top: 0.66rem;

            .plant_type_r,
            .plant_type_l {
              flex: 1;
            }

            .plant_type_item {
              // flex: 1;
              display: flex;
              padding-left: 0.48rem;

              img {
                width: 0.74rem;
                height: 0.74rem;
                margin-right: 0.25rem;
              }

              div {
                display: flex;
                flex-direction: column;

                span {
                  font-size: 0.38rem;
                  font-family: Impact-Regular, Impact;
                  font-weight: 400;
                  color: #fff200;
                  line-height: 0.5rem;
                  letter-spacing: 1px;
                }

                label {
                  font-size: 0.18rem;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  color: #ffffff;
                  opacity: 0.45;
                }
              }
            }

            .count_item {
              flex: 1;
              display: flex;
              flex-direction: column;
              padding-left: 0.48rem;
              margin-top: 0.7rem;
              position: relative;

              label {
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                margin-bottom: 0.18rem;
                opacity: 0.45;
              }

              span {
                font-size: 0.33rem;
                font-family: Impact-Regular, Impact;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.28rem;
                letter-spacing: 1px;

                i {
                  font-style: normal;
                  font-size: 0.2rem;
                  color: #fafafa;
                  opacity: 0.45;
                }
              }
            }

            .plant_count,
            .animal_count {
              padding-left: 0.79rem;

              &::before {
                content: '';
                width: 0.08rem;
                height: 0.38rem;
                background: #00e0db;
                border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                position: absolute;
                left: 0.48rem;
                top: 0.11rem;
              }
            }

            .animal_count {
              &::before {
                background: #5d2cfe;
              }
            }
          }
        }

        .warrning {
          margin-top: 0.36rem;
          background: linear-gradient(154deg, #0b286a 0%, rgba(11, 40, 106, 0.19) 57%, #0b286a 100%);
          height: 5.4rem;

          .warrning_content {
            display: flex;
            justify-content: space-between;
            margin-top: 0.13rem;

            // height: 5.125rem;
            .warrning_content_item {
              width: 2.81rem;
              height: 4.65rem;
              // background: linear-gradient(154deg, #0b286a 0%, rgba(11, 40, 106, 0.19) 57%, #0b286a 100%);
              opacity: 0.94;

              .add_num {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                img {
                  width: 0.94rem;
                  height: 1.01rem;
                  margin-top: 0.26rem;
                }

                span {
                  font-size: 0.45rem;
                  font-family: Impact-Regular, Impact;
                  font-weight: 400;
                  color: #fff200;
                  line-height: 0.33rem;
                  margin-top: 0.38rem;
                }

                label {
                  margin-top: 0.24rem;
                  font-size: 0.18rem;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  color: #ffffff;
                  line-height: 0.18rem;
                }
              }

              .total_num {
                margin-top: 0.61rem;
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.2rem;
                padding-left: 0.25rem;
              }

              .type_num {
                display: flex;
                margin-top: 0.48rem;

                div {
                  flex: 1;
                  padding-left: 0.25rem;
                  display: flex;
                  flex-direction: column;

                  &:last-child {
                    padding-left: 0.45rem;

                    span {
                      color: #fff200;
                    }
                  }

                  span {
                    font-size: 0.18rem;
                    font-family: Impact-Regular, Impact;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 0.22rem;
                  }

                  label {
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 0.18rem;
                    opacity: 0.6;
                    margin-top: 0.1rem;
                  }
                }
              }
            }
          }

          .map-font {
            width: 100%;
            height: 0.7rem;
            // background-color: #fff200;
            padding: 0 0 0 0.3rem;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;

            .font-box {
              width: 1.5375rem;
              height: 0.3125rem;
              // background-color: #00e0db;
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              font-size: 0.125rem;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              position: relative;

              .radio {
                width: 8px;
                height: 8px;
                // background-color: red;
                border-radius: 50%;
                position: absolute;
                left: -0.05rem;
              }
            }

            .font-box:nth-child(2) {
              margin-left: 0.35rem;
            }

            .font-box:nth-child(3) {
              margin-left: 0.35rem;
            }

            .font-box:nth-child(5) {
              margin-left: 0.35rem;
            }
          }
        }

        .device {
          width: 5.75rem;
          height: 5.4rem;
          display: flex;
          flex-direction: column;
          background: linear-gradient(64deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(0, 22, 78, 0.62) 100%);
          padding: 0 0.125rem;

          .device_content {
            height: 4.5rem;
            display: flex;
            flex-wrap: wrap;
            width: 5.75rem;

            .device_item {
              width: 2.81rem;
              height: 2.31rem;
              opacity: 0.94;
              margin-top: 0.14rem;
              margin-right: 0.13rem;
              display: flex;
              align-items: center;
            }
          }
        }

        .service {
          margin-top: 0.36rem;
          height: 5.4rem;
          background: linear-gradient(154deg, rgba(11, 40, 106, 0.62) 0%, rgba(11, 40, 106, 0.19) 57%, rgba(11, 40, 106, 0.62) 100%);
          padding: 0 0.125rem;

          .service_content {
            width: 5.75rem;
            height: 4.65rem;
            opacity: 0.94;
            margin-top: 0.14rem;
            display: flex;
            flex-wrap: wrap;

            // padding-top: 0.45rem;
            .service_item {
              width: 50%;
              display: flex;
              padding-left: 0.45rem;

              img {
                width: 0.5rem;
                height: 0.5rem;
                margin-right: 0.28rem;
              }

              div {
                display: flex;
                flex-direction: column;

                label {
                  font-size: 0.18rem;
                  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                  font-weight: 500;
                  color: rgba(255, 255, 255, 0.6);
                }

                span {
                  margin-top: 0.19rem;
                  font-size: 0.25rem;
                  font-family: Impact-Regular, Impact;
                  font-weight: 400;
                  color: #fff200;
                  line-height: 0.25rem;
                }
              }
            }
          }
        }
      }

      .box-center {
        width: 11.98rem;
        // background: url('../../../assets/yq/index_map_bg.png');
        background-size: 100% 100%;
        position: relative;

        .tips {
          width: 5.25rem;
          height: 1.5rem;
          // background-color: red;
          position: absolute;
          top: 0.35rem;
          right: 0.15rem;
          display: flex;
          flex-direction: column;

          .env {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.18rem;
            cursor: pointer;

            .env-text {
              height: 0.625rem;
              display: flex;
              align-items: center;
            }

            img {
              width: 0.7375rem;
              height: 0.55rem;
            }

            span {
              font-size: 0.375rem;
              font-family: Impact-Regular, Impact;
              font-weight: 400;
              color: #fff200;
            }

            label {
              font-size: 0.175rem;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              margin: 0 0.175rem 0 0.275rem;
            }
          }
        }

        .map_main {
          width: 100%;
          height: 100%;
        }
      }

      .center {
        width: 100%;
        flex: 1;
        // background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
      }

      .num {
        width: 100%;
        height: 0.4375rem;
        // background-color: #00E0DB;
        margin-top: 0.325rem;
        padding-left: 0.175rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .title {
          font-size: 0.175rem;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }

        .card {
          flex: 1;
          height: 100%;
          margin-left: 0.25rem;
          // background-color: olivedrab;
          display: flex;

          .card-num {
            width: 0.4375rem;
            height: 0.4375rem;
            background: linear-gradient(154deg, #0b286a 0%, rgba(11, 40, 106, 0.19) 57%, #0b286a 100%);
            font-size: 0.325rem;
            font-family: Impact-Regular, Impact;
            background: rgba(0, 254, 255, 0.12);
            box-shadow: inset 0px 0px 6px 0px rgba(0, 224, 219, 0.2);
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid rgba(0, 254, 255, 0.102);
            font-weight: 400;
            color: #fff200;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 0.125rem;
          }

          .font {
            color: #fff200;
            font-size: 0.325rem;
            font-family: Impact-Regular, Impact;
            font-weight: 400;
            color: #fff200;
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.125rem;
            margin-right: 0.125rem;
          }
        }
      }

      .pie {
        width: 100%;
        // flex: 1;
        height: 3rem;
        // background-color: cadetblue;
      }

      .map-font {
        width: 100%;
        height: 0.7rem;
        // background-color: #fff200;
        padding: 0 0 0 0.3rem;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;

        .font-box {
          width: 1.5375rem;
          height: 0.3125rem;
          // background-color: #00e0db;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          font-size: 0.125rem;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          position: relative;

          .radio {
            width: 8px;
            height: 8px;
            // background-color: red;
            border-radius: 50%;
            position: absolute;
            left: -0.05rem;
          }
        }

        .font-box:nth-child(2) {
          margin-left: 0.35rem;
        }

        .font-box:nth-child(3) {
          margin-left: 0.35rem;
        }

        .font-box:nth-child(5) {
          margin-left: 0.35rem;
        }
      }
    }
  }
  .fillWidth {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -99;
}
}

</style>
